module.exports = __webpack_public_path__ + "img/94.2b3c95c3.svg";